import React, { useState } from "react";
import classes from "./FileList.module.css";
import FileRow from "../FileRow/FileRow";
import { Models } from "@prisma/client";
import { SelectedState } from "../../../pages/FileSystemPage";
import MenuButton from "../../Buttons/MenuButton";
import { useAppSelector } from "../../../app/hooks/hooks";
import { selectUser } from "../../../app/features/auth/authSlice";
interface FileListProps {
    files: Models[] | undefined;
    selectedState: SelectedState;
    setSelectedState: React.Dispatch<React.SetStateAction<SelectedState>>;
    uploadFileCallback: () => void;
    update: () => void;
}

function FileList({
    files,
    selectedState,
    setSelectedState,
    uploadFileCallback,
    update,
}: FileListProps) {
    const currentUser = useAppSelector(selectUser);

    if (!files) return <></>;

    if (!files.length) {
        return (
            <div className={classes.noFilesBut}>
                <div>Where are no loaded files</div>
                <MenuButton onClick={uploadFileCallback}>
                    Upload first files
                </MenuButton>
            </div>
        );
    }

    return (
        <div className={classes.filesWrap} onClick={() => setSelectedState({})}>
            <div className={classes.header_wrap}>
                <div>File name</div>
                {currentUser ? <div>Version</div> : <div>Remain time</div>}
                <div>File size</div>
                <div>Date</div>
            </div>
            {files
                .filter((p) => p.active)
                .sort(
                    (a, b) =>
                        new Date(a.load_date).getTime() -
                        new Date(b.load_date).getTime()
                )
                .map((value) => (
                    <FileRow
                        key={value.model_id}
                        file={value}
                        version={value.version}
                        setSelectedState={setSelectedState}
                        selectedState={selectedState}
                        update={update}
                    ></FileRow>
                ))}
        </div>
    );
}

export default FileList;
